<span class="float-end">
    <button type="submit" class="btn btn-primary" [disabled]="!form.valid" i18n>Save</button>&nbsp;
    <button type="button" class="btn btn-danger" [disabled]="!adsPlacement.id" (click)="delete()"
        i18n>Delete</button>&nbsp;
</span>
<h3 *ngIf="adsPlacement.id" class="mt-3"><span i18n>Product placement:</span> {{ adsPlacement.name }}</h3>
<h3 *ngIf="!adsPlacement.id" class="mt-3" i18n>New product placement</h3>

<ng-container *ngIf="adsPlacement.id">
    Created: {{ adsPlacement.created_at | date: 'short' }} {{ adsPlacement.created_by.first_name }} {{
    adsPlacement.created_by.last_name }} &bullet;
    Modified: {{ adsPlacement.updated_at | date: 'short' }} {{ adsPlacement.updated_by.first_name }} {{
    adsPlacement.updated_by.last_name }}
</ng-container>

<ul ngbNav #nav="ngbNav" [(activeId)]="activeTab" (activeIdChange)="setFragment($event)" class="nav-tabs mt-3">
    <li [ngbNavItem]="'basics'">
        <button ngbNavLink i18n>Basics</button>
        <ng-template ngbNavContent>
            <form [formGroup]="form" (ngSubmit)="save()">
                <div class="row g-3">
                    <div class="col-8">
                        <div class="row g-3">
                            <div class="col-12">
                                <label class="form-label d-block" i18n>Assets</label>
                                <ng-container *ngIf="adsPlacement.id">
                                    <div class="input-group mb-3">
                                        <input [(ngModel)]="editPrompt" [ngModelOptions]="{standalone: true}"
                                            (keydown.enter)="$event.preventDefault(); (disableEdit || edit())"
                                            type="text" class="form-control" id="name" autocomplete="off"
                                            placeholder="Image edit instructions" i18n-placeholder>
                                        <button [disabled]="disableEdit || !editPrompt.trim()" (click)="edit()"
                                            type="button" class="btn btn-primary" i18n>Edit</button>
                                        <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                            <li><button [disabled]="disableEdit" type="button" class="dropdown-item"
                                                    (click)="discard()" i18n>Discard changes</button></li>
                                        </ul>
                                        <button type="button" class="btn btn-secondary"
                                            data-bs-toggle="dropdown"><fa-icon
                                                [icon]="fa.faEllipsis"></fa-icon></button>
                                    </div>
                                    <div class="row g-3">
                                        <div (click)="pictureViewer()" class="col-6 position-relative cursor-pointer">
                                            <div
                                                style="position: absolute; top: 0.5rem; left: 1rem; background-color: rgba(0, 0, 0, 0.5); color: white; padding: 0.25rem 0.5rem; border-radius: 0.25rem;">
                                                <span i18n>Main picture</span>
                                                <span *ngIf="adsPlacement.assignment.updating"
                                                    class="spinner-border spinner-border-sm text-light ms-2"
                                                    role="status"></span>
                                            </div>
                                            <img [src]="adsPlacement.assignment.picture" class="img-fluid">
                                        </div>
                                        <div *ngFor="let product of adsPlacement.assignment.products; let i = index"
                                            (click)="pictureViewer(product.product, i)"
                                            class="col-6 position-relative cursor-pointer">
                                            <div
                                                style="position: absolute; top: 0.5rem; left: 1rem; background-color: rgba(0, 0, 0, 0.5); color: white; padding: 0.25rem 0.5rem; border-radius: 0.25rem;">
                                                <span>{{ product.product.name }}</span>
                                                <span *ngIf="product.product.updating"
                                                    class="spinner-border spinner-border-sm text-light ms-2"
                                                    role="status"></span>
                                            </div>
                                            <img [src]="product.product.picture" class="img-fluid">
                                        </div>
                                    </div>
                                </ng-container>
                                <div *ngIf="!adsPlacement.id && loaded" class="card">
                                    <div class="card-body">
                                        <div class="card-body d-flex align-items-center justify-content-center text-muted"
                                            i18n>Save product placement first</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="row g-3">
                            <div class="col-12">
                                <label for="name" class="form-label">Name</label>
                                <input type="text" class="form-control" id="name" formControlName="name"
                                    autocomplete="off">
                            </div>
                            <div class="col-12">
                                <label for="organizations" class="form-label" i18n>Country</label>
                                <select class="form-select" id="organization_id" formControlName="organization_id"
                                    [ngClass]="{'pe-none': adsPlacement.id}">
                                    <option [ngValue]="null" i18n>Select country</option>
                                    <option *ngFor="let organization of organizations | localeSort: 'country'"
                                        [ngValue]="organization.id">{{ organization.country }}</option>
                                </select>
                            </div>
                            <div class="col-12">
                                <label for="assignment_id" class="form-label" i18n>Service category</label>
                                <select class="form-select" id="assignment_id" formControlName="assignment_id"
                                    [ngClass]="{'pe-none': adsPlacement.id}">
                                    <option [ngValue]="null" i18n>Select service category</option>
                                    <option *ngFor="let assignment of assignments | localeSort: 'name'"
                                        [ngValue]="assignment.id">{{ assignment.name }}</option>
                                </select>
                            </div>
                            <div class="col-12">
                                <label for="status" class="form-label" i18n>Status</label>
                                <select class="form-select" id="status" formControlName="status">
                                    <option *ngFor="let status of adsPlacementStatuses | keyvalue"
                                        [ngValue]="status.key">{{ status.value }}</option>
                                </select>
                            </div>
                            <div class="col-12">
                                <label for="start_date" class="form-label" i18n>Dates</label>
                                <div class="input-group">
                                    <input type="date" class="form-control" id="start_date"
                                        formControlName="start_date">
                                    <span class="input-group-text">-</span>
                                    <input type="date" class="form-control" id="end_date" formControlName="end_date">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </ng-template>
    </li>
    <li [ngbNavItem]="'statistics'">
        <button ngbNavLink i18n>Statistics</button>
        <ng-template ngbNavContent>
            <form [formGroup]="statisticsForm" (ngSubmit)="getStatistics()">
                <div class="input-group mb-3">
                    <input type="date" class="form-control" id="start_date" formControlName="start_date">
                    <span class="input-group-text">-</span>
                    <input type="date" class="form-control" id="end_date" formControlName="end_date">
                    <select class="form-select" id="group_by" formControlName="group_by">
                        <option [ngValue]="null" i18n>Group by</option>
                        <option *ngFor="let groupBy of groupByOptions | keyvalue" [ngValue]="groupBy.key">{{ groupBy.value }}</option>
                    </select>
                    <button type="button" class="btn btn-primary" [disabled]="!statisticsForm.valid" (click)="getStatistics()" i18n>Search</button>
                </div>

                <table class="table table-hover">
                    <thead>
                        <th class="align-middle" i18n>Asset</th>
                        <th class="align-middle" i18n>Country</th>
                        <th class="align-middle" i18n>City</th>
                        <th class="align-middle" i18n>Views</th>
                    </thead>
                    <tbody>
                        <tr *ngFor="let asset of statistics">
                            <td class="align-middle">
                                <ng-container *ngIf="asset.product">
                                    {{ asset.product.name }}
                                </ng-container>
                                <ng-container *ngIf="!asset.product" i18n>
                                    Main picture
                                </ng-container>
                            </td>
                            <td class="align-middle">{{ asset.country }}</td>
                            <td class="align-middle">{{ asset.city }}</td>
                            <td class="align-middle">{{ asset.views }}</td>
                        </tr>
                    </tbody>
                </table>
            </form>
        </ng-template>
    </li>
</ul>
<div [ngbNavOutlet]="nav" class="my-3"></div>